import { render, staticRenderFns } from "./Anniversary15PromoBanner.vue?vue&type=template&id=4dbc2312&scoped=true&"
import script from "./Anniversary15PromoBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Anniversary15PromoBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Anniversary15PromoBanner.vue?vue&type=style&index=0&id=4dbc2312&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc2312",
  null
  
)

export default component.exports